export const addLanguageToFileName = (fileName, language) => {
  const parts = fileName.split('.');
  if (parts.length > 1) {
    const extension = `.${parts.pop()}`;
    const nameWithoutExtension = parts.join('.');
    return `${nameWithoutExtension}_${language}${extension}`;
  }
  return `${fileName}_${language}`;
};

// returns fileName extension
const getExtension = (filename) => filename.split('.').slice(-1)[0].toLowerCase();

export const isPdfExtension = (filename) => getExtension(filename) === 'pdf';

// returns true if it is an uploaded document (it is not in open search)
export const isTempDocument = (externalId) => externalId.includes('isTemp');

export const mapMetadataFields = (reference, metadataFields) => {
  return {
    ...metadataFields,
    ...reference,
    sourceUrl: metadataFields?.sourceUrl?.href || metadataFields?.sourceUrl || '',
  };
};
